<script>
    import axios from "axios";
    export let settings;
    export let dataapi;
    export let datanik;
    let apidata = [];
    let showform = false;
    if(dataapi){
    axios
      .get(settings.url + "/sipade/lay_api/" + dataapi + "/" + datanik, {
        params: {
          authorization: settings.token,
        },
      })
      .then(function (response) {
        apidata = response.data;
        showform = true;
      });
      }
</script>

{#if showform}
<table border="0" width="100%" class="layTemplate" id="TEMPLATE-layTemplate" style="display: table;">
                    <tbody>
                
                        {#if apidata.form}
                        {#each apidata.form as [key, value]}
                        <input type="hidden" name="{key}" value="{value}">
                        {/each}
                        <tr>
                            <td align="center">Menggunakan data sesuai permohonan,
                                silahkan lanjut ke <b>saklar tombol "CEK"</b> dibawah</td>
                        </tr>
                        <tr>
                        </tr>
                        {/if}
                    </tbody>
                </table>
            {/if}